// Общая математика графиков телеметрии: сравнение участников на этапе
// (RiderCompareModal) и график одной активности (ActivityChartModal)
// строятся по одинаковым сэмплам, которые готовит ActivityTelemetryService.
//
// Индексы полей сэмпла: [t, distance, altitude, speed, power, heart_rate, cadence]
export const S_TIME = 0;
export const S_DISTANCE = 1;
export const S_ALTITUDE = 2;
export const S_SPEED = 3;
export const S_POWER = 4;
export const S_HR = 5;
export const S_CADENCE = 6;

// Сглаживание: скользящее среднее по SMOOTH_WINDOW сэмплам в каждую сторону.
// Сэмпл телеметрии — это 5 секунд (SAMPLE_STEP в ActivityTelemetryService),
// то есть окно усреднения примерно полминуты
export const SMOOTH_WINDOW = 3;

// Шаг делений оси: 1, 2, 5 или 10 в своем порядке величины
export const niceStep = (rough) => {
  if (!(rough > 0)) return 1;

  const pow = Math.pow(10, Math.floor(Math.log10(rough)));
  const norm = rough / pow;
  const step = norm <= 1 ? 1 : (norm <= 2 ? 2 : (norm <= 5 ? 5 : 10));

  return step * pow;
};

// Значения показателя по оси X: [[x, value|null], ...].
// По какой оси раскладывать (дистанция или время) задает xIndex.
// При включенном усреднении сырая пила мощности превращается в читаемую линию
export const buildPoints = (samples, valueIndex, smoothed, xIndex = S_DISTANCE) => {
  const list = samples || [];

  return list.map((sample, index) => {
    const x = sample[xIndex];

    if (!smoothed) {
      const raw = sample[valueIndex];
      return [x, raw === null || raw === undefined ? null : raw];
    }

    let sum = 0;
    let count = 0;

    for (let i = Math.max(0, index - SMOOTH_WINDOW); i <= Math.min(list.length - 1, index + SMOOTH_WINDOW); i += 1) {
      const value = list[i][valueIndex];

      if (value !== null && value !== undefined) {
        sum += value;
        count += 1;
      }
    }

    return [x, count > 0 ? Math.round(sum / count) : null];
  });
};

// Линия строится отрезками: там, где датчик не писал значение, будет разрыв,
// а не прямая через всю дистанцию
export const buildSegments = (points) => {
  const segments = [];
  let current = [];

  points.forEach(([x, value]) => {
    if (value === null) {
      if (current.length > 1) segments.push(current);
      current = [];
      return;
    }

    current.push([x, value]);
  });

  if (current.length > 1) segments.push(current);

  return segments;
};

export const averageValue = (points) => {
  const values = points.map(([, value]) => value).filter(value => value !== null);

  if (values.length === 0) return null;

  return Math.round(values.reduce((sum, value) => sum + value, 0) / values.length);
};

// Значение в точке оси X — берем ближайшую точку, без интерполяции.
// tolerance задается в единицах оси: метры для дистанции, секунды для времени
export const valueAtX = (points, x, tolerance = 100) => {
  if (points.length === 0) return null;

  let low = 0;
  let high = points.length - 1;

  while (high - low > 1) {
    const mid = (low + high) >> 1;
    if (points[mid][0] <= x) low = mid; else high = mid;
  }

  // За финишем значений уже нет
  if (x > points[points.length - 1][0] + tolerance) return null;

  const nearest = Math.abs(points[low][0] - x) <= Math.abs(points[high][0] - x)
    ? points[low]
    : points[high];

  return nearest[1];
};

// Сглаживание профиля высот: в FIT высота шумит на метровом уровне
export const smoothProfile = (raw, window = 4) => {
  if (!raw || raw.length < 5) return raw || [];

  return raw.map((point, index) => {
    let sum = 0;
    let count = 0;

    for (let i = Math.max(0, index - window); i <= Math.min(raw.length - 1, index + window); i += 1) {
      sum += raw[i][1];
      count += 1;
    }

    return [point[0], sum / count];
  });
};
